<template>
  <div
    class="ui wide sidebar overlay right menu"
    ref="sdbr"
    style="padding: 10px !important; z-index: 10 !important"
  >
    <div class="ui form" style="width: 100%">
      <h5 class="ui dividing header">{{ $t("node info") }}</h5>
      <div class="field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="name" v-model="setup.name" />
      </div>
      <!-- <div class="field">
        <label for>{{ $t("title") }}</label>
        <input type="text" name="title" v-model="setup.title" />
      </div> -->
      <div class="field">
        <label for>{{ $t("user in charge") }}</label>
        <div class="ui multiple search selection dropdown" ref="user_dropdown">
          <input type="hidden" name="user" />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("user") }}</div>
          <div class="menu"></div>
        </div>
      </div>
      <!-- <div class="ui three item top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="general">{{ $t("general") }}</a>
        <a class="item" data-tab="evaluation">{{ $t("evaluation") }}</a>
        <a class="item" data-tab="exceptions">{{ $t("exceptions") }}</a>
      </div>
      <div
        class="ui bottom attached active tab segment"
        data-tab="general"
      ></div> -->
      <!-- <div class="ui bottom attached tab segment" data-tab="evaluation">
        <h5 class="ui dividing header">
          {{ $t("360 evaluation setup") }}
        </h5>
        <div class="field">
          <label for>{{ $t("auto evaluation") }}</label>
          <div
            class="ui multiple search selection dropdown"
            ref="auto_evaluation_dropdown"
          >
            <input type="hidden" name="auto_evaluation" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("evaluation") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("superior level evaluation") }}</label>
          <div
            class="ui multiple search selection dropdown"
            ref="superior_evaluation_dropdown"
          >
            <input type="hidden" name="superior_evaluation" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("evaluation") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("same level evaluation") }}</label>
          <div
            class="ui multiple search selection dropdown"
            ref="same_level_evaluation_dropdown"
          >
            <input type="hidden" name="same_level_evaluation" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("evaluation") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("inferior level evaluation") }}</label>
          <div
            class="ui multiple search selection dropdown"
            ref="inferior_evaluation_dropdown"
          >
            <input type="hidden" name="inferior_level_evaluation" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("evaluation") }}</div>
            <div class="menu"></div>
          </div>
        </div>
      </div> -->
      <div class="ui bottom attached tab segment" data-tab="exceptions">
        <h5 class="ui dividing header">
          {{ $t("exceptions") }}
        </h5>
        <div class="field">
          <label for>{{ $t("superior level") }}</label>
          <div
            class="ui multiple search selection dropdown"
            ref="superior_exception_dropdown"
          >
            <input type="hidden" name="superior_exception" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("exceptions") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("same level") }}</label>
          <div
            class="ui multiple search selection dropdown"
            ref="same_level_exception_dropdown"
          >
            <input type="hidden" name="same_level_exception" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("exceptions") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("inferior level") }}</label>
          <div
            class="ui multiple search selection dropdown"
            ref="inferior_exception_dropdown"
          >
            <input type="hidden" name="inferior_exception_evaluation" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("exceptions") }}</div>
            <div class="menu"></div>
          </div>
        </div>
      </div>
      <div class="ui grid">
        <div class="eight wide column">
          <div class="ui fluid mini green icon labeled button" @click="apply">
            <i class="check icon"></i>
            {{ $t("apply") }}
          </div>
        </div>
        <div class="eight wide column">
          <div class="ui fluid mini red icon labeled button" @click="remove">
            <i class="trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
        <div class="sixteen wide column" style="padding-top: 0">
          <div
            class="ui fluid mini orange icon labeled right floated button"
            @click="add_below"
          >
            <i class="plus icon"></i>
            {{ $t("add below") }}
          </div>
        </div>
        <!-- <div class="sixteen wide column" style="padding-top: 0">
          <div
            class="ui fluid mini blue icon labeled right floated button"
            @click="deploy"
          >
            <i class="rocket icon"></i>
            {{ $t("deploy") }}
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { v4 } from "uuid";
import { local_api, error_toast } from "@/utils";
import filters from "@/filters";

export default {
  name: "TeacherOrganizationTreeComposerSidebar",
  components: {},
  props: {},
  filters: filters,
  data() {
    return {
      setup: {
        id: "",
        name: "",
        title: "",
        user: "",
      },
      ds: {},
      all_users: [],
    };
  },
  computed: {},
  methods: {
    processTree(tree, parent) {
      let vm = this;
      tree.parent = parent;
      if (tree.children) {
        for (let i = 0; i < tree.children.length; i++) {
          tree.children[i] = vm.processTree(tree.children[i], tree);
        }
      }
      return tree;
    },
    show(setup, ds) {
      // console.log("showing sidebar", setup, ds);
      let vm = this;
      vm.ds = vm.processTree(ds, undefined);
      // vm.setup = setup;
      Object.keys(setup).map((k) => {
        if (vm.setup[k] != undefined) {
          // console.log("setting", k);
          vm.setup[k] = setup[k];
        }
      });

      /** Check if user is coming in the payload data */
      window.jQuery(vm.$refs.user_dropdown).dropdown("clear");
      if (vm.setup.user) {
        setTimeout(() => {
          let usrs = vm.setup.user.split(",");
          window.jQuery(vm.$refs.user_dropdown).dropdown("set selected", usrs);
        }, 200);
      }

      /** Sidebar setup */
      window
        .jQuery(vm.$refs.sdbr)
        .sidebar({
          dimPage: false,
          context: window.jQuery("#sdbrctxt"),
          onHide() {
            Object.keys(vm.setup).map((k) => {
              vm.setup[k] = "";
            });
          },
        })
        .sidebar("show");

      window.jQuery(vm.$refs.tabs).find(".item").tab();
    },
    apply() {
      let vm = this;
      let targetNode = vm.searchTree(vm.ds, vm.setup.id);
      if (targetNode) {
        Object.keys(vm.setup).map((k) => {
          targetNode[k] = vm.setup[k];
        });
      }

      vm.$emit("init_chart");
      window.jQuery(vm.$refs.sdbr).sidebar("hide");
    },
    searchTree(element, matchingTitle) {
      if (element.id == matchingTitle) {
        return element;
      } else if (element.children != null) {
        var i;
        var result = null;
        for (i = 0; result == null && i < element.children.length; i++) {
          result = this.searchTree(element.children[i], matchingTitle);
        }
        return result;
      }
      return null;
    },
    remove() {
      this.removeNode(null, this.setup.id);

      this.$emit("init_chart");
    },
    add_below() {
      let vm = this;
      let targetNode = vm.searchTree(vm.ds, vm.setup.id);
      if (targetNode) {
        if (targetNode.children) {
          targetNode.children.push({
            id: v4(),
            name: vm.$t("new"),
            title: vm.$t("new"),
            user: "",
          });
        } else {
          targetNode.children = [
            {
              id: v4(),
              name: vm.$t("new"),
              title: vm.$t("new"),
              user: "",
            },
          ];
        }
      }

      vm.$emit("init_chart");
    },
    removeNode(element, matchingTitle) {
      if (!element) {
        if (this.ds.id == matchingTitle) this.ds = {};
        else this.removeNode(this.ds, matchingTitle);
      } else if (element.children != null) {
        let idx = element.children.findIndex((c) => c.id == matchingTitle);
        if (idx >= 0) {
          element.children.splice(idx, 1);
          window.jQuery(".ui.sidebar").sidebar("hide");
        } else {
          for (let i = 0; i < element.children.length; i++) {
            this.removeNode(element.children[i], matchingTitle);
          }
        }
      }
    },
    deploy() {
      let vm = this;
      vm.$emit("deploy_node", vm.setup.id);
    },
  },
  mounted() {
    // this.init_searchs();
  },
  created() {
    let vm = this;

    /** Get users */
    local_api(vm, "post", "/user/do-get-all")
      .then((users) => {
        if (users) {
          vm.all_users = users;
          let vls = users.map((u) => {
            return { name: u.username, value: u.user_id };
          });
          window
            .jQuery(vm.$refs.user_dropdown)
            .dropdown({
              fullTextSearch: "exact",
              onChange(value, text) {
                vm.setup.user = value;
                vm.setup.title = text;
              },
            })
            .dropdown("setup menu", { values: vls });
        }
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
};
</script>
